module.exports = __webpack_public_path__ + "static/img/faq-2.aca9cd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/faq-2.png
// module id = 59Zy
// module chunks = 4